import type { ReactElement } from 'react';
import React from 'react';

import Head from 'next/head';

import useTranslation from '@framework/hooks/useTranslation';

import Login from '@accounts/pages/NewLogin/Login';

const LoginPage = (): ReactElement | null => {
    const { t } = useTranslation();

    const documentTitle = t('Log in to Sherpany meeting management software');

    return (
        <>
            <Head>
                <title>{documentTitle}</title>
                <meta
                    name="description"
                    itemProp="description"
                    content="Are you a user of Sherpany software looking to prepare your next leadership meeting? Log in to your Sherpany account here."
                />
                <meta
                    name="keywords"
                    itemProp="keywords"
                    content="Leadership, Sherpany, Time, meeting, director, executive, board member, committee"
                />
            </Head>
            <Login />
        </>
    );
};

export default LoginPage;
